import { Dialog, DialogContent, DialogProps } from "@mui/material";
import { Box } from "@mui/system";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";
import { BaseEntityDto } from "@/core/api/generated/v1";

import TenantStructureMembershipOfEntityEdit, {
  TenantStructureMembershipOfEntityEditProps,
} from "./TenantStructureMembershipOfEntityEdit";

export interface OwnProps<TEntity extends BaseEntityDto> {
  tenantStructureMembershipOfEntityEditProps: TenantStructureMembershipOfEntityEditProps<TEntity>;
}

type Props<TEntity extends BaseEntityDto> = OwnProps<TEntity> & DialogProps;

export default function TenantStructureMembershipOfEntityEditModal<TEntity extends BaseEntityDto>({
  tenantStructureMembershipOfEntityEditProps,
  ...dialogProps
}: Props<TEntity>) {
  return (
    <Dialog fullWidth maxWidth='md' {...dialogProps}>
      <AppModalTitle
        onClose={() => dialogProps?.onClose && dialogProps?.onClose({}, "escapeKeyDown")}
      >{`Add entities to a department and location`}</AppModalTitle>
      <DialogContent>
        <Box sx={{ py: 1 }}>
          <TenantStructureMembershipOfEntityEdit {...tenantStructureMembershipOfEntityEditProps} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
